import moment from "moment";
import "moment-timezone"; // this adds functionality on to `moment` object (`tz` property)
import React, { ReactNode } from "react";
import * as S from "../../constants/StringConstants";
import { IProposalRevision } from "../../store/models/proposalRevision.models";

export default (revision: IProposalRevision): ReactNode => {
  const dateFormat = "M/D/YYYY, h:mm a";
  const revisionMoment = moment(revision.revisionDate);

  return (
    <div key={`revision[${revision.revisionID}]`}>
      <div>{S.REV_ITEM_SENT(revisionMoment.format(dateFormat))}</div>
    </div>
  );
};
